import { createdButtonRender } from './operation-render'
import { getCustomRowCellAlignClass } from 'public/components/kye-table2/config/columns.js'

export function createButtonOptionsRender(buttonOpt, { vm, permission }) {
  return function (h, renderArgs) {
    return h('div', {
      class: ['table2-warp-button-options', ...getCustomRowCellAlignClass(renderArgs.column)].filter(Boolean),
    }, [createdButtonRender(h, buttonOpt, renderArgs, { vm, column: renderArgs.column, permission })])
  }
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/button-options-render.js